'use client';
import { SelectInput } from '@curology/ui-components-web/react/SelectInput';
import { SelectOption } from '@curology/ui-components-web/react/SelectInput/SelectOption';
import { useState } from 'react';

import { useFlowContext } from '@/components/flow/hooks/useFlowContext';
import { type AvailableTimeSlots } from '@/services/liveConsultationService/types';
import { type OptionsType } from '@/services/liveConsultationService/utils';
import { useFlag } from '@/utils/featureFlags/client';

import SubmitButton from './submitButton';
import { scheduleConsultation } from '../actions';

const Form = ({
  availableTimeSlots,
  dateOptions,
  timeOptions,
  secondaryButton,
}: {
  availableTimeSlots: AvailableTimeSlots;
  dateOptions: OptionsType;
  timeOptions: OptionsType;
  secondaryButton: JSX.Element;
}) => {
  const { brand } = useFlowContext();
  const [preferredLanguage, setPreferredLanguage] = useState('English');
  const showPreferredLanguage = useFlag('show-preferred-language');

  return (
    <form action={scheduleConsultation}>
      <input type="hidden" name="brand" value={brand} />
      <div className="cur-flex cur-flex-col cur-gap-4">
        <div className="cur-flex cur-items-center cur-flex-col md:cur-flex-row cur-gap-4">
          <SelectInput
            label="Date"
            required
            className="cur-flex-grow cur-w-full"
          >
            {dateOptions.map((dateOption) => (
              <SelectOption key={dateOption.value} value={dateOption.value}>
                {dateOption.label}
              </SelectOption>
            ))}
          </SelectInput>
          <SelectInput
            label="Time"
            required
            className="cur-flex-grow cur-w-full"
            name="appointmentTimeSlotId"
          >
            {timeOptions.map((timeOption) => (
              <SelectOption key={timeOption.value} value={timeOption.value}>
                {timeOption.label}
              </SelectOption>
            ))}
          </SelectInput>
        </div>
        {showPreferredLanguage && (
          <div>
            <SelectInput
              label="Preferred language"
              required
              className="cur-min-w-[150px] md:cur-min-w-[200px]"
              name="preferredLanguage"
              defaultValue={preferredLanguage}
              onChange={(event) => {
                const value = event.target.value;
                setPreferredLanguage(value);
              }}
            >
              {availableTimeSlots.languages.map((language) => (
                <SelectOption key={language} value={language}>
                  {language}
                </SelectOption>
              ))}
            </SelectInput>
          </div>
        )}
      </div>
      <div className="cur-flex cur-flex-col cur-mt-12 cur-justify-center cur-items-center">
        <SubmitButton>Schedule your call</SubmitButton>
        {secondaryButton}
      </div>
    </form>
  );
};

export default Form;
